import { ValueError } from "../error/ValueError.js";
import { debug } from "./debug.js";
/** Is a given value a class constructor? */
export function isConstructor(value) {
    return typeof value === "function" && value.toString().startsWith("class");
}
/** Is a value an instance of a class? */
export function isInstance(value, type) {
    return value instanceof type;
}
/** Assert that a value is an instance of something. */
export function assertInstance(value, type) {
    if (!(value instanceof type))
        throw new ValueError(`Must be instance of ${debug(type)}`, value);
}
